import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  leftIcon: {
    fontSize: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
  },
  dotIcon: {
    fontSize: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
  },
  invisible: {
    visibility: 'hidden',
  },
  statusText: {
    fontSize: pxToRem(12),
    fontWeight: 400,
  },
});
